"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageContentComponentKeys = void 0;
var ImageContentComponentKeys;
(function (ImageContentComponentKeys) {
    ImageContentComponentKeys["BlogLink"] = "blog.branch-link";
    ImageContentComponentKeys["BranchLink"] = "utils.branch-link";
    ImageContentComponentKeys["ExternalLink"] = "utils.external-link";
    ImageContentComponentKeys["JobLink"] = "utils.job-link";
    ImageContentComponentKeys["PageLink"] = "utils.page-link";
    ImageContentComponentKeys["ServiceLink"] = "utils.service-link";
})(ImageContentComponentKeys = exports.ImageContentComponentKeys || (exports.ImageContentComponentKeys = {}));
